import { all, takeLatest } from 'redux-saga/effects';

import { rebootSystemService } from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* modelWatchers() {
  yield all([takeLatest(EntryActionTypes.REBOOT_SYSTEM, () => rebootSystemService())]);
}
